<div class="wrapper" (click)="disableScroll()" *ngIf="isLoading | async" [@fadeInOnEnter] [@fadeOutOnLeave]>
    <mat-progress-spinner 
        [color]="'warn'"
        [diameter]="70"
        [mode]="'indeterminate'">
    </mat-progress-spinner>
</div>